export default [
  {
    path: "*",
    component: () => import("@/views/tests/NotFound.vue"),
  },
];
